<template>
	<div id="report_wrapper">
		<v-dialog
            v-model="projectDataDialog"
            transition="scale-transition"
            origin="center center"
            fullscreen
            style="z-index: 2000">
            <v-card class="d-flex align-start">
                <div style="width: 100%">
                    <ProjectDetails
                        :user_id="this_userId"
                        :project_id="this_projectId"
                        :client_info="this_clientInfo"
                        :project_statuses="project_statuses"
                        :openTab="projectDetailsTabToOpen"
                        @closeDetailDialog="closeDetailDialog" />
                </div>
            </v-card>
        </v-dialog>

		<v-navigation-drawer
            v-model="foreignQualificationDetails"
            app
            relative
            right
            temporary
            width="46%"
            style="z-index: 2000">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="primary--text text--darken-2 font-weight-bold" :style="`border-bottom: 1px solid ${'primary-darken-2'}`">Foreign Qualification Details</v-card-title>
                <v-card-text class="pt-3">
                    <!-- <EmpProjectActivity
                        :projectID="projectForActivity"  /> -->
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

		<div>
            <div class="px-4 d-flex justify-space-between">
                <div class="sansation info--text d-inline"><h2>EMP Status Report</h2></div>
				<v-btn
					v-if="filteredEmpReports.length"
					color="primary darken-1"
					small
					hide-details
					class="d-inline"
					@click="exportEmpReportData()">
					Export
				</v-btn>
            </div>

            <div class="pt-0 pb-4 px-4 justify-space-between" flat>
                <div class="d-flex d-block justify-space-between">

					<div class="d-inline" style="max-width: 30%; min-width: 30%;">
						<v-text-field 
							v-model="search"
							label="Search" 
							color="primary darken-1" 
							single-line 
							hide-details 
							append-icon="mdi-magnify"
							@input="filterProjects()">
						</v-text-field>
					</div>

					<div class="d-inline">
						<div class="d-flex d-block justify-space-between mb-2">
							<v-autocomplete 
								v-model="filterby.status"
								:items="project_statuses" 
								item-text="internal_label"
								item-value="value"
								label="Status" 
								:hint="filteredEmpReports.length ? project_status_metadata.join(', ') : ''"
								persistent-hint
								multiple
								class="mr-3" 
								color="primary darken-1"
								@change="filterProjects()">
									
									<template v-slot:prepend-item>
										<v-list-item
											@click="toggleSelectAll"
										>
											<v-list-item-action>
												<!-- Use a checkbox to show selection state -->
												<v-icon :color="allSelected ? 'primary' : ''">
													{{ allSelected ? 'mdi-close-box' : 'mdi-checkbox-blank-outline' }}
												</v-icon>
											</v-list-item-action>
											<v-list-item-content>
												<v-list-item-title>
													{{ allSelected ? 'Deselect All' : 'Select All' }}
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-divider></v-divider>
									</template>

									<template v-slot:message="{ message }">
										<span v-html="message"></span>
									</template>
							</v-autocomplete>

							<v-autocomplete 
								v-model="filterby.state"
								:items="states"
								hide-details
								multiple
								class="d-inline mx-3"
								label="State"
								@change="filterProjects()">
							</v-autocomplete>
						</div>

						<div class="d-flex d-block justify-space-between mb-2">
							<v-autocomplete 
								v-model="filterby.report_type"
								:items="report_type_options_list"
								hide-details
								multiple
								class="d-inline mr-3"
								label="Annual Report Type"
								@change="filterProjects()">
							</v-autocomplete>

							<v-autocomplete 
								v-model="filterby.report_date"
								:items="report_months"
								item-text="text"
								item-value="value"
								hide-details
								multiple
								class="d-inline mx-3"
								label="Annual Report Month"
								@change="filterProjects()">
							</v-autocomplete>
							
							<v-autocomplete 
								v-model="filterby.completion_status"
								:items="annual_report_filing_status_list"
								hide-details
								multiple
								class="d-inline ml-3"
								label="Annual Report Status"
								@change="filterProjects()">
							</v-autocomplete>
							
						</div>
					</div>
				</div>

				<div class="d-flex justify-end mt-3 px-4" v-if="filtered_projects_cnt">
                    {{ filtered_projects_cnt }} total results
                </div>
			</div>
		</div>

		<v-data-table 
			:headers="emp_report_headers" 
			:items="filteredEmpReports" 

            @current-items="getFiltered"

            :loading="table_loading"
			loading-text="Loading... Please wait"

            :options.sync="options"
            item-key="project_id" 

			fixed-header
            hide-default-footer
            :height="'calc(100vh - 300px)'"
		>
			<template v-slot:no-data>
                <div class="text-center pt-12">
                    <v-icon large>mdi-alert-circle</v-icon>
                    <p class="mt-2">No projects found matching your filters.</p>
                </div>
            </template>

            <template v-slot:no-results>
                <div class="text-center pt-12">
                    <v-icon large>mdi-alert-circle</v-icon>
                    <p class="mt-2">No projects found matching your filters.</p>
                </div>
            </template>

			<template v-slot:item="{ item }">
				<tr class="table-row"
                    :key="item.project_id + item.user_id">
							
					<!-- Contact Info -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						<div v-for="(contact, index) in item.contact_data" :key="index" :class="index==0 ? 'mb-1' : 'my-1'" class="ma-0 pa-0">
							<v-tooltip top content-class="contact_tooltip">
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										icon
										x-small
										class=""
										color="primary"
										v-bind="attrs"
										v-on="on"
										target="_blank"
										@click.stop
										:href="`mailto:${contact.user_email}`">
										<v-icon>mdi-email</v-icon>
									</v-btn>                            
								</template>
								<span>{{ contact.user_email }}</span>
							</v-tooltip>
							{{ contact.user_name }}
						</div>
					</td>

					<!-- Entity Name -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ item.entity_name }}
					</td>

					<!-- Project Status -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						<v-chip 
                            small
                            label
                            :color="item.status_progress_color"
                            text-color="white"
                            class="mr-1"
                            style="padding: .25rem .4rem !important">
                            <span class="font-weight-bold">
                                {{item.status_label }}
                            </span>
                        </v-chip>
					</td>

					<!-- Project Auto-Renew Status -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						<v-icon 
							class="ml-2"
							:color="item.auto_renew ? 'primary' : 'error'"
							:title="item.auto_renew ? 'Auto-Renew Enabled' : 'Auto-Renew Disabled'">
							{{ item.auto_renew ? 'mdi-check' : 'mdi-close' }}
						</v-icon>
					</td>

					<!-- State -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ item.state }}
					</td>


					<!-- Management -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ formatManagement(item.management) }}
					</td>

					<!-- <template v-slot:[`item.recommended_annual_meeting_date`]="{ item }">
						<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">{{ formatDate(item.recommended_annual_meeting_date) }}</td>
					</template>  -->

					<!-- Annual Report Type -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item, 'filing-data' )">
						{{ optionLookup(report_type_options_list, item.annual_report_type) }}
					</td>

					<!-- Annual Filing Date -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item, 'filing-data' )">
						{{ formatDate(item.annual_report_filing_date, item) }}
					</td>
			
					<!-- Filing Completion Status -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item, 'filing-data' )">
						{{ optionLookup(annual_report_filing_status_list, item.annual_report_filing_status) }}
					</td>
				
					<!-- Foreign Qualifications -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item, 'filing-data' )" v-html="formatForeignQualifications(item.fq_data)"></td>

					<!-- Resolutions Used -->
					<td  class="text-start align-text-top" @click.stop="openProjectDetails( item, 'resolutions' )">
						{{item.resolutionsUsed}}
					</td>

					<!-- Date Initialized -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ formatDate(item.date_initialized, item) }}
					</td>

					<!-- Consult Date -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ psrDateFormat( item.tasks.consult) }}
					</td>

					<!-- Q2 Date -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ psrDateFormat( item.tasks.q2) }}
					</td>

					<!-- Q3 Date -->
					<td class="text-start align-text-top" @click.stop="openProjectDetails( item )">
						{{ psrDateFormat( item.tasks.q3) }}
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>


<script>
import axios from 'axios';
import Cookie from 'js-cookie';
import { saveAs } from 'file-saver';
import { safeParseJson } from '../../helpers/safe-json'

import appUrls from '../../helpers/environment';
import { capitalizeFirstWord, setStatusData } from '../utilities'

import ProjectDetails from '../ProjectDetails'
import UserData_Dashboard from '../UserData_Dashboard'

export default {
	name: 'empReports',

	components: {
		ProjectDetails,
		UserData_Dashboard
	},

	props: {
		triggerUserFeedback: Function
	},

	data: () => ({
		states: [],
		selectedDays: 10,
		project_status_metadata: [],
		empReports: [],
		currentFilteredRows: [],
		filteredEmpReports: [],
		foreignQualificationDetails: false,
		projectDataDialog: false,
		this_userId: '',
		this_projectId: '',
		this_clientInfo: [],
		project_statuses: [],
		projectForActivity: '',
		userForActivity: '',
		projectDetailsTabToOpen: 'overview',
		table_loading: false,
		report_months: [
			{ value: 1,  text: 'January' },
			{ value: 2,  text: 'February' },
			{ value: 3,  text: 'March' },
			{ value: 4,  text: 'April' },
			{ value: 5,  text: 'May' },
			{ value: 6,  text: 'June' },
			{ value: 7,  text: 'July' },
			{ value: 8,  text: 'August' },
			{ value: 9,  text: 'September' },
			{ value: 10, text: 'October' },
			{ value: 11, text: 'November' },
			{ value: 12, text: 'December' },
		],
		emp_report_headers: [
			
			{ text: 'Contact Info', 			  	value: 'contact_data', 					align: 'start', sortable: true, width: '210px', class: 'tbl_headers' },
			{ text: 'Entity Name', 				  	value: 'entity_name', 					align: 'start', sortable: true, width: '260px' },
			{ text: 'Status',               		value: 'status_label',               	align: 'start', sortable: true, width: '170px' },	
			{ text: "Auto Renew",             		value: "auto_renew",                	align: 'start', sortable: true, width: '120px' },
			{ text: 'State', 					  	value: 'state', 						align: 'start', sortable: true, width: '100px' },
			{ text: 'Management', 				  	value: 'management', 					align: 'start', sortable: true, width: '120px' },
			{ text: 'Annual Report Type', 		  	value: 'annual_report_type', 			align: 'start', sortable: true, width: '130px' },
			{ text: 'Annual Report Filing Date',  	value: 'annual_report_filing_date', 	align: 'start', sortable: true, width: '155px' },
			{ text: 'Annual Report Filing Status',	value: 'annual_report_filing_status', 	align: 'start', sortable: true, width: '160px' },
			{ text: 'Foreign Qualification Data', 	value: 'fq_data', 						align: 'start', sortable: true, width: '220px' },
			{ text: 'Resolutions Used', 		  	value: 'resolutionsUsed', 				align: 'start', sortable: true, width: '120px' },
			{ text: 'Date Initiated', 			  	value: 'date_initialized', 				align: 'start', sortable: true, width: '120px' },
			{ text: 'Consult Call', 			  	value: 'tasks.consult', 				align: 'start', sortable: true, width: '120px' },
			{ text: 'Data Sheet', 				  	value: 'tasks.q2', 						align: 'start', sortable: true, width: '120px' },
			{ text: 'Comp Data', 				  	value: 'tasks.q3', 						align: 'start', sortable: true, width: '120px' },
		],
		annual_report_filing_status_list: [],
		report_type_options_list: [],
		filtered_projects_cnt: 0,
		search: '',
		filterby: {
			search: '',
			status: [],
			state: [],
			report_type: [],
			report_date: [],
			completion_status: []
		},

		options: {
			sortBy: ['state'],
			sortDesc: [false],
			// Initialize other options as needed
			itemsPerPage: -1,
			multiSort: true
		},
  	}),

	computed: {
		showFilterArchiveToggle () {
			// return ['root','super'].includes(Cookie.get('levs'))
			return true
		},
		allSelected () {
			return this.project_statuses.length > 0 && this.filterby.status.length === this.project_statuses.length;
		},
		// closeDateRangeText () {
		// 	if (!this.filterby.close_date_range || !this.filterby.close_date_range.length) return '';
		// 	return this.filterby.close_date_range.join(' ~ ');
		// },
		// initDateRangeText () {
		// 	if (!this.filterby.initialized_date_range || !this.filterby.initialized_date_range.length) return '';
		// 	return this.filterby.initialized_date_range.join(' ~ ');
		// },
	},
  
  	watch: {
		search (val) {
			this.filterby.search = val
			localStorage.setItem('empDashboardFilters', JSON.stringify(this.filterby))
		}
	},

	created () {
		this.getStatusData()
		this.getLists()
		
		const savedOptions = localStorage.getItem('empDashboardOptions');
		if ( savedOptions ) {
			const parsedOptions = safeParseJson(savedOptions, null)
			if (parsedOptions && typeof parsedOptions === 'object') {
				this.options = parsedOptions
			}
		}

		const savedFilters = localStorage.getItem('empDashboardFilters');
		if ( savedFilters ) {
			const parsedFilters = safeParseJson(savedFilters, null)
			if (parsedFilters && typeof parsedFilters === 'object') {
				this.filterby = { ...this.filterby, ...parsedFilters }
			}
			this.filterby.status = Array.isArray(this.filterby.status) ? this.filterby.status : []
			this.filterby.state = Array.isArray(this.filterby.state) ? this.filterby.state : []
			this.filterby.report_type = Array.isArray(this.filterby.report_type) ? this.filterby.report_type : []
			this.filterby.report_date = Array.isArray(this.filterby.report_date) ? this.filterby.report_date : []
			this.filterby.completion_status = Array.isArray(this.filterby.completion_status) ? this.filterby.completion_status : []
			this.search = this.filterby.search || ''
		} else {
			this.resetFilters(true)
		}
	},

	mounted() {
		this.getEmpReports()
	},

	methods: {
		debouncedSearch() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(() => {
				this.getEmpReports()
			}, 500);
		},

		openProjectDetails: async function ( item, tabToOpen='overview' ) {
			this.projectDetailsTabToOpen = tabToOpen || 'overview'
			this.projectDataDialog = true
			this.this_userId = item.contact_data[0].user_id
			this.this_projectId = item.project_id
			this.this_clientInfo = item.contact_data
		},

		openForeignQualificationActivity: async function ( item ) {
			this.projectForActivity = item.project_id
			this.userForActivity = item.contact_data[0].user_id
			this.foreignQualificationDetails = true
		},

		onUpdateOptions(newOptions) {
			this.options = newOptions;
			// Save sort options to localStorage
			localStorage.setItem('empDashboardOptions', JSON.stringify(newOptions));
		},
		getFiltered: async function (rs) {
			this.currentFilteredRows = Array.isArray(rs) ? [...rs] : []
			this.filtered_projects_cnt = rs.length
			this.calculateFilteredProjects(rs)

			localStorage.setItem('empDashboardFilters', JSON.stringify(this.filterby));
		},

		calculateFilteredProjects(filteredReports) {
			this.filtered_projects_cnt = filteredReports.length

			this.project_statuses.forEach(status => {
				status.count = filteredReports.filter(r => r.status === status.value).length;
			});

			// With no status selected every status is shown, so list counts for all of them
			const selectedStatuses = this.filterby.status && this.filterby.status.length ? this.filterby.status : null
			this.project_status_metadata = this.project_statuses
				.filter(status => status.count && (!selectedStatuses || selectedStatuses.includes(status.value)))
				.map(status => `${status.internal_label}: <strong>${status.count}</strong>`)
		},

		setModuleSelection: function () {
			this.filterby.search = this.search
			this.filterby.status = []
			this.filterby.state = []
			this.filterby.report_type = []
			this.filterby.report_date = []
			this.filterby.completion_status = []
		},

		resetFilters: function (skipPersist = false) {
			this.search = ''
			this.filterby.search = ''
			this.filterby.status = []
			this.filterby.state = []
			this.filterby.report_type = []
			this.filterby.report_date = []
			this.filterby.completion_status = []
			if (!skipPersist) {
				localStorage.setItem('empDashboardFilters', JSON.stringify(this.filterby))
			}
			this.filterProjects()
		},

		calcStatusMetaData: function ( prj ) {
			const status_color_data     = setStatusData(prj.status, this.project_statuses)
			const status_label          = status_color_data.status_internal_label
			const status_color          = status_color_data.status_color
			const status_progress_color = status_color_data.status_progress_color
			const status_text_color     = status_color_data.status_text_color

			return {
				status_label, 
				status_color, 
				status_progress_color, 
				status_text_color
			};
		},

		// Method to toggle selection (either select all or deselect all)
		toggleSelectAll() {
			if (this.allSelected) {
				// If all are selected, deselect all
				this.filterby.status = [];
			} else {
				// If not all are selected, select all
				this.filterby.status = this.project_statuses.map(item => item.value);
			}
			// Trigger your filter function after selection change
			this.filterProjects();
		},

		getEmpReports: async function () {
			this.table_loading = true
			this.empReports = []

			try {
				const emp_report_rs = await axios.get(`${appUrls.api}/api/admin/emp_reports`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
				})
				
				if (emp_report_rs.data.outcome) {
					this.empReports = emp_report_rs.data.emps;

					for (let b in this.empReports) {
						const prj = this.empReports[b];
						this.empReports[b].status_label = this.calcStatusMetaData( prj ).status_label;
						this.empReports[b].status_color = this.calcStatusMetaData( prj ).status_color;
						this.empReports[b].status_progress_color = this.calcStatusMetaData( prj ).status_progress_color;
						this.empReports[b].status_text_color = this.calcStatusMetaData( prj ).status_text_color;
					}

					this.filteredEmpReports = this.empReports ;
					this.currentFilteredRows = [...this.empReports]
					this.filterProjects();

					this.table_loading = false;
					// this.$emit('triggerUserFeedback', true, emp_report_rs.data.message)
				} else {
					this.table_loading = false;          
					this.$emit('triggerUserFeedback', true, 'There was a problem searching for EMP Projects.', 'accent')
				}
			} catch (error) {
				console.log(error);
			}
		},

		exportEmpReportData: async function () {
			const rowsForExport = this.currentFilteredRows.length ? this.currentFilteredRows : this.filteredEmpReports
			if (!rowsForExport.length) {
				this.$emit('triggerUserFeedback', true, 'No projects found to export.', 'accent')
				return
			}
			const projectIds = rowsForExport
				.map(item => item && item.project_id)
				.filter(Boolean)
			if (!projectIds.length) {
				this.$emit('triggerUserFeedback', true, 'No projects found to export.', 'accent')
				return
			}

			let exportData = ''
			try {
				const export_rs = await axios.post(`${appUrls.api}/api/admin/emp_reports/export`, {
					project_ids: projectIds
				}, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
				})

				if (!export_rs.data || !export_rs.data.outcome || !export_rs.data.buf) {
					this.$emit('triggerUserFeedback', true, 'There was a problem exporting EMP Projects.', 'accent')
					return
				}

				exportData = export_rs.data.buf
			} catch (error) {
				console.log(error)
				this.$emit('triggerUserFeedback', true, 'There was a problem exporting EMP Projects.', 'accent')
				return
			}

			const this_fileExt = '.xlsx';
			const this_fileDate = this.createDateString();
			const this_fileData = new Buffer(exportData, 'base64');
			const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
			const this_fileName = 'emp-report_'+this_fileDate+this_fileExt;
			
			const this_blob = new Blob([this_fileData], {type: this_fileType});
			saveAs(this_blob, this_fileName);
		},

		optionLookup(options, value) {
			if (!value) return null;
			
			const option = options.filter((o) => {
				return o.value == value
			})
			
			if (option[0]) {
				return option[0].text;
			}
			// console.log('opt lookukp', option[0], value);
			return null;      
		},
		
		formatDate( d, i, digits_of_year = 4 ) {
			// console.log('item:', i.entity_name, 'date:', d);
			if (!d) return null;
			
			const date = new Date(d);
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const day = date.getDate();
			
			const dateString = `${month}/${day}/${digits_of_year == 2 ? year.toString().substr(2, 2) : year}`;
			// console.log('dateString', dateString);
			return dateString;
		},

		createDateString( date = false ) {
			const d = date ? new Date(date) : new Date()
			const year = String(d.getFullYear())
			const month = String(d.getMonth() + 1).padStart(2, '0')
			const day = String(d.getDate()).padStart(2, '0')
			const secs = String(d.getSeconds())
			const msec = String(d.getMilliseconds())
			
			return year.concat('', month.concat('', day.concat('', secs.concat('', msec))));
		},

		formatManagement(mgmt) {
			if ( mgmt == undefined ) {
				return '';
			} else {
				return capitalizeFirstWord(mgmt);
			}
		},

		formatForeignQualifications ( fq_data ) {
			// console.log(fq_data)
			if ( fq_data == undefined || fq_data.length === 0 ) {
				return '';
			} else if ( fq_data.length > 0 ) {
				if ( fq_data[0] == 'Not Provided' ) {
					return 'Not Provided';
				} else if ( fq_data[0] == 'None' ) {
					return 'None';
				} else {
					return fq_data.map(fq => {
						return 'Status: ' + fq.fq_filing_status + '<br>Type: ' + fq['report-type-display'] + '<br> Due Date: ' + fq.filing_due_date + '<br> State: ' + fq.state;
					}).join('<br><br>');
				}
			}
		},

		psrDateFormat(psrDate) {
			if (psrDate) {
				if ( psrDate.completed_date !== null ) {
					return `Completed: ${this.formatDate(psrDate.completed_date)}`;
				} else if ( psrDate.estimated_completion_date !== null ) {
					return `Estimated: ${this.formatDate(psrDate.estimated_completion_date)}`;
				} else if ( psrDate.assigned_date !== null ) {
					return `Estimated: ${this.formatDate(psrDate.assigned_date)}`;
				}
			}
			return "N/A";
		},

		getLists: async function () {
			let optionsLists = [
				{'name': 'states', 'type': 'txt' },
				{'name': 'filing_statuses', 'type': 'txt'},
				{'name': 'report_type_options', 'type': 'txt'},
			];

			try { 
				const lists_rs = await axios.post(`${appUrls.api}/api/lists`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
					list_options: optionsLists
				})
				
				if (lists_rs.data.outcome) {
					this.arrLists = lists_rs.data.lists;
					// SET PROPERTIES WITH THEIR APPROPRIATE LIST
					for ( let l in this.arrLists ) {
						if ( this.arrLists[l].name == 'states' ) this.states = this.arrLists[l].list
						if ( this.arrLists[l].name == 'filing_statuses' ) this.annual_report_filing_status_list = this.arrLists[l].list
						if ( this.arrLists[l].name == 'report_type_options' ) this.report_type_options_list = this.arrLists[l].list
					}
				} else {
					this.$emit('triggerUserFeedback', true, 'There was a problem retrieving lists.', 'accent')
				}
			} catch ( error ) {
				console.log(error);
			}
		},

		filterProjects: function () {
			let filteredEmpReports = [...this.empReports]
			const searchText = (this.filterby.search || this.search || '').trim().toLowerCase()

			if ( searchText ) {
				filteredEmpReports = filteredEmpReports.filter((r) => {
					const contactNames = (r.contact_data || []).map(contact => `${contact.name || ''} ${contact.email || ''}`).join(' ')
					const searchableText = [
						r.entity_name,
						r.state,
						r.management,
						r.annual_report_type,
						r.annual_report_filing_status,
						contactNames
					].filter(Boolean).join(' ').toLowerCase()

					return searchableText.includes(searchText)
				})
			}

			if ( this.filterby.status && this.filterby.status.length ) {
				filteredEmpReports = filteredEmpReports.filter((r) => {
					return this.filterby.status.includes(r.status)
				})
			}

			if ( this.filterby.state && this.filterby.state.length ) {
				const selectedStates = this.filterby.state.map(value => String(value).toLowerCase())
				filteredEmpReports = filteredEmpReports.filter((r) => {
					return r.state && selectedStates.includes(String(r.state).toLowerCase())
				})
			}

			if ( this.filterby.report_type && this.filterby.report_type.length ) {
				const selectedTypes = this.filterby.report_type.map(value => String(value))
				filteredEmpReports = filteredEmpReports.filter((r) => {
					return r.annual_report_type && selectedTypes.includes(String(r.annual_report_type))
				})
			}

			if ( this.filterby.report_date && this.filterby.report_date.length ) {
				const selectedMonths = this.filterby.report_date.map(value => Number(value))
				filteredEmpReports = filteredEmpReports.filter((r) => {
					if (!r.annual_report_filing_date) return false
					const month = new Date(r.annual_report_filing_date).getMonth() + 1
					return selectedMonths.includes(month)
				})
			}

			if (  this.filterby.completion_status && this.filterby.completion_status.length) {
				const selectedCompletionStatuses = this.filterby.completion_status.map(value => String(value))
				filteredEmpReports = filteredEmpReports.filter((r) => {
					return r.annual_report_filing_status && selectedCompletionStatuses.includes(String(r.annual_report_filing_status))
				})
			}

			this.filteredEmpReports = filteredEmpReports
			this.currentFilteredRows = [...filteredEmpReports]
			this.calculateFilteredProjects(filteredEmpReports)
			localStorage.setItem('empDashboardFilters', JSON.stringify(this.filterby));
			this.table_loading = false;
		},

		getStatusData: async function () {
			try {
				const get_project_status_data = await axios.get(`${appUrls.api}/api/project_status_data`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
				})

				this.project_statuses = get_project_status_data.data.status_data
				this.project_statuses.forEach(obj => {
					obj.count = 0;
				});

				// Statuses can load after the reports, so refresh the counts in the hint
				if ( this.empReports.length) this.calculateFilteredProjects(this.filteredEmpReports )

			} catch ( error ) {
				console.log(error);
			}
		},

		closeDetailDialog: function ( val ) {
			this.projectDataDialog = false
			this.this_userId = ''
			this.this_projectId = ''
			this.this_clientInfo = []
			this.projectDetailsTabToOpen = 'overview'
			this.getEmpReports()
		},

		resetSearchParams: function() {
			this.resetFilters();
		},
		
		beginCall: function ( digits ) {
			window.open(`tel:${digits}`)
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.filter-container {
        position: sticky;
        top: 0;
        background-color: white;
        z-index: 1000;
        padding-top: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .view-height-max {
        height: 100vh;
    }
    .v-dialog__content {
        width: 98vw !important;
    }
    #report_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 0 0 0 0;
        display: flex;
        flex-direction: column;
        /* height: 100vh; */
    }
    .header_bg_color {
        background-color: var(--v-primary-darken3)
    }
    tr:nth-of-type(even) {
        background-color: rgba(223, 233, 236, .25);
    }
    td.no_extra_border {
        border-bottom: 0 !important;
    }
    .v-data-table__wrapper {
        overflow-x: auto !important;
    }
    .title {
        padding: .5rem;
    }
    .multi_project_modules {
        font-size: .70rem;
        font-weight: lighter;
    }
    #new_btn {
        width: 100%;
        text-align: right;
    }
    .listing_row {
        text-align: left;
    }
    .tbl_headers {
        padding: 0 !important;
    }
    .dialog_title_bkg {
        background-color: #2196f3; /* #17a2b8 */
        color: #fff
    }
    .icon-size-small {
        width: 2.25rem;
    }

	.v-chip.v-chip--outlined.v-chip.v-chip.multi-project-chip {
        background-color: white !important;
        padding: .625rem .5rem !important; 
        margin-bottom: .35rem !important;
        font-weight: bold
    }
    .v-data-table { 
        overflow-x: scroll !important;
        overflow-y: scroll !important;
    }
    >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 1em !important;
        font-size: x-small !important;
        color: #333 !important;
        margin: 0 !important;
        height: 36px !important;
        border-top: 1px solid #EDEDED !important;
    }
    >>> .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 1em .8em 1em !important;
        margin: 0 !important;
        font-size: small !important;
        cursor: pointer !important;
    }
    >>> .v-data-table__expanded {
        background-color: #fff !important;
        padding: .8em 1em .8em 1em !important;
        height: 90px !important;
    }
    .text-underline {
        text-decoration: underline;
    }
    .fade-out-btn {
        transition: opacity 0.5s ease-out; /* Smooth fade-out transition */
    }
    .fade-out-btn[v-cloak] {
        display: none; /* Prevent flash before Vue mounts */
    }
    .fade-out-btn:not([v-show]) {
        opacity: 0; /* Fade out when hidden */
    }
    .align-text-top {
       vertical-align: top;
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
    .spin-refresh {
        animation: spin-refresh 1s linear infinite;
    }
    @keyframes spin-refresh {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/EMPStatus.vue